module.exports = __webpack_public_path__ + "static/media/shuffle.2188ad5e.svg";